import { render, staticRenderFns } from "./PromoTargetDialog.vue?vue&type=template&id=45bb2822&scoped=true"
import script from "./PromoTargetDialog.vue?vue&type=script&lang=js"
export * from "./PromoTargetDialog.vue?vue&type=script&lang=js"
import style0 from "./PromoTargetDialog.vue?vue&type=style&index=0&id=45bb2822&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bb2822",
  null
  
)

export default component.exports